import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import { CxShipmentLocation } from '../../models/shipment-location';
import CxShipmentLocationActions from '../actions/cx-shipment-location.actions';

export type CxShipmentLocationEntity = CxShipmentLocation;
export interface CxShipmentLocationState extends EntityState<CxShipmentLocationEntity> {
  activeEntityId: string;
}

export const entityAdapter = createEntityAdapter<CxShipmentLocationEntity>({
  selectId: ({ shipmentLocationId }) => `${shipmentLocationId}`,
});

export const initialCxShipmentLocationState = entityAdapter.getInitialState({
  activeEntityId: null,
});

export const cxProductTypeReducer = createReducer(
  initialCxShipmentLocationState,

  on(CxShipmentLocationActions.selectEntity, (state, { id: activeEntityId }) => {
    return {
      ...state,
      activeEntityId,
    };
  }),

  on(CxShipmentLocationActions.updateEntity, (state, { payload }) => entityAdapter.upsertOne(payload, state)),
  on(CxShipmentLocationActions.updateEntities, (state, { payload }) => entityAdapter.upsertMany(payload, state)),
);

export function reducer(state: CxShipmentLocationState, action: Action) {
  return cxProductTypeReducer(state, action);
}

export const selectActiveEntityId = (state: CxShipmentLocationState) => state.activeEntityId;
export const { selectIds, selectEntities, selectAll, selectTotal } = entityAdapter.getSelectors();
